import type { Category } from '@/entities/shared/category/category';

/** Items whose form shows active ingredient and dose. */
export function isMedical(category: Category): boolean {
  return category === 'medication' || category === 'first_aid';
}
